import React from 'react'
import * as R from 'ramda'
import PropTypes from 'prop-types'
import { ThemeProvider } from 'styled-components'
import isReactComponent from 'sidecar-utils/lib/isReactComponent'
import theme from 'sidecar-theme'

import enhance from './enhance'
import {
  Wrapper,
  StyledIcon,
  ValidationIcon,
  Label,
  Input,
  IconLabel,
} from './styles'

export const InputText = ({
  label,
  plainIcon,
  placeholder,
  beforeIcon,
  afterIcon,
  input: { name, value, onChange, ...restInput },
  meta,
  meta: { active, visited, touched, error },
  error: customError,
  validator,
  clearLabel,
  wideLabel,
  readOnly = false,
  ...rest
}) => (
  <ThemeProvider
    theme={
      touched && (error || customError)
        ? theme.inputTextError
        : theme.inputTextDefault
    }
  >
    <Wrapper className="inputWrapper">
      {R.cond([
        [R.is(String), () => <StyledIcon before name={beforeIcon} />],
        [isReactComponent, Component => <Component />],
        [React.isValidElement, R.identity],
        [R.isNil, () => null],
      ])(beforeIcon)}

      <Input
        id={name}
        visited={visited || !R.isNil(value)}
        onChange={onChange}
        value={value}
        placeholder={placeholder}
        name={name}
        beforeIcon={beforeIcon}
        validator={validator}
        {...restInput}
        {...rest}
        labelAsPlaceholder={!!label}
        readOnly={readOnly}
      />
      {label && (
        <Label
          htmlFor={name}
          considerIcon={beforeIcon}
          {...meta}
          clear={clearLabel}
          wide={wideLabel}
        >
          {label}
        </Label>
      )}

      {R.cond([
        [R.is(String), () => <StyledIcon after name={afterIcon} />],
        [isReactComponent, Component => <Component />],
        [React.isValidElement, R.identity],
        [R.isNil, () => null],
      ])(afterIcon)}

      {!active && validator && touched && (
        <IconLabel after htmlFor={name}>
          <ValidationIcon
            name={error ? 'x' : 'checkmark'}
            plainIcon={plainIcon}
          />
        </IconLabel>
      )}
    </Wrapper>
  </ThemeProvider>
)

InputText.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  beforeIcon: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  afterIcon: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  input: PropTypes.object,
  meta: PropTypes.object,
  validator: PropTypes.string,
}

export default enhance(InputText)



// WEBPACK FOOTER //
// ./src/sidecar-ui/lib/InputText/index.js